import CreateBulkEntities from '../CreateBulkEntities'

const CreateBulkConfig = () => {
  return <CreateBulkEntities type="bulkConfig" />
}
export default CreateBulkConfig
